import { render, staticRenderFns } from "./formPermohonanUMK.vue?vue&type=template&id=6efd417a&scoped=true&"
import script from "./formPermohonanUMK.vue?vue&type=script&lang=js&"
export * from "./formPermohonanUMK.vue?vue&type=script&lang=js&"
import style0 from "./formPermohonanUMK.vue?vue&type=style&index=0&id=6efd417a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efd417a",
  null
  
)

export default component.exports